// PrivilegeService.js

import { HTTP } from "@/utils/http-common"

export default {
  async getAll(queryArgs = null) {
    const path = `/event/privileges`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    return results
  },

  async getUserProjectPrivileges(userId, projectId) {
    const path = `/event/${projectId}/${userId}/privileges`
    // const params = { user_id, project_id }
    return (await HTTP.get(path)).data
  },

  async get(privilegeId) {
    const path = `/event/privileges/${privilegeId}`
    return (await HTTP.get(path)).data
  },

  async post(projectId, userId, data) {
    const path = `/event/${projectId}/${userId}/privileges`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/event/privileges/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(privilegeId) {
    const path = `/event/privileges/${privilegeId}`
    return (await HTTP.delete(path)).data
  }
}
